// extracted by mini-css-extract-plugin
export default {"container":"Highlight_container__sTKUj","txt":"Highlight_txt__ftve4"};